/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * High-level playback type classification.
 * Indicates the general category of video content being played.
 */
export enum VideoPlaybackType {
  /**
   * No active playback - player is idle.
   */
  IDLE = "IDLE",

  /**
   * Live TV content playback.
   */
  LIVE_TV = "LIVE_TV",

  /**
   * IP-based stream playback (VOD, NDVR, SOCU).
   */
  IP_STREAM = "IP_STREAM"
}
